// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__33PBQ","choiceBoxes":"toolbarselects_choiceBoxes__37FRc","simpleField":"toolbarselects_simpleField__2WxTl"};